import { getReportHeaders } from "@adapters/infrastructures/urlConfig/Reports/reportHeaders";
import urlConfig from "@adapters/infrastructures/urlConfig/Reports/reportsUrl";
import contractCommodityMapper from "@domains/mapper/Reports/ContractStatement/contractCommodityMapper";
import contractStatementMapper from "@domains/mapper/Reports/ContractStatement/contractStatementMapper";
import contractStatementPDF from "@domains/mapper/Reports/ContractStatement/contractStatementPDF";
import { getIsInIFrame } from "@domains/utils/tokenParser";
class ContractReportRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async getContractStatement(req) {
        let url = new URL(urlConfig.contractNote + "note");
        const accountCode = await this.accountDetails.getAccountCode();
        url.searchParams.append("accountId", req.accountId);
        url.searchParams.append("fromDate", req.fromDate);
        url.searchParams.append("toDate", req.toDate);
        url.searchParams.append("type", req.type);
        url.searchParams.append("segment", req.segment);
        let resp = await this.http.makeApiCall({
            method: "GET",
            headers: getReportHeaders(accountCode),
            url: url.toString(),
            avoidAuthToken: getIsInIFrame(),
        });
        return contractStatementMapper(resp);
    }
    async getContractCommodity(req) {
        var _a, _b;
        let url = new URL(urlConfig.contractNote + "note/commodity");
        const accountCode = await this.accountDetails.getAccountCode();
        url.searchParams.append("accountId", req.accountId);
        url.searchParams.append("fromDate", req.fromDate);
        url.searchParams.append("toDate", req.toDate);
        url.searchParams.append("type", req.type);
        url.searchParams.append("exchange", req.exchange);
        url.searchParams.append("entity", req.entity);
        let resp = await this.http.makeApiCall({
            method: "GET",
            headers: getReportHeaders(accountCode),
            url: url.toString(),
            avoidAuthToken: getIsInIFrame(),
        });
        return contractCommodityMapper((_b = (_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.contractNoteList) !== null && _b !== void 0 ? _b : []);
    }
    async downloadContractPDF(req) {
        let url = new URL(urlConfig.contract + "/pdflist");
        const accountCode = await this.accountDetails.getAccountCode();
        let resp = await this.http.makeApiCall({
            method: "POST",
            headers: getReportHeaders(accountCode),
            url: url.toString(),
            body: req,
            avoidAuthToken: getIsInIFrame(),
        });
        return contractStatementPDF(resp);
    }
    async emailContractPDF(req) {
        let url = new URL(urlConfig.contractNote + "note/email");
        const accountCode = await this.accountDetails.getAccountCode();
        let resp = await this.http.makeApiCall({
            method: "POST",
            headers: getReportHeaders(accountCode),
            url: url.toString(),
            body: req,
            avoidAuthToken: getIsInIFrame(),
        });
        return resp.data.status;
    }
    async viewContractPDF(req) {
        let url = new URL(urlConfig.contractNote + "note/view/pdf");
        const accountCode = await this.accountDetails.getAccountCode();
        let resp = await this.http.makeApiCall({
            method: "POST",
            headers: getReportHeaders(accountCode),
            url: url.toString(),
            body: req,
            avoidAuthToken: getIsInIFrame(),
        });
        return contractStatementPDF(resp);
    }
}
export default ContractReportRepository;
